import React, { useState, useEffect } from "react";
import "./Home.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // Import Link for navigation
import HomePlant from "../Components/HomePlant";
import useScrollReveal from "../Hooks/useScrollReveal"; // Import the custom hook

function Home(props) {
  const { t } = useTranslation("global");
  const [langState, setLangState] = useState(
    localStorage.getItem("lang") || "en"
  );

  useScrollReveal(".reveal", "reveal-visible"); // Apply the scroll reveal to elements with the 'reveal' class

  useEffect(() => {
    /**
     * Updates language state when a language change is detected in local storage.
     */
    const handleLanguageChange = () => {
      setLangState(localStorage.getItem("lang") || "en");
    };

    window.addEventListener("storage", handleLanguageChange);

    return () => {
      window.removeEventListener("storage", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    setLangState(localStorage.getItem("lang") || "en");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("lang")]);

  return (
    <div className="home">
      {/* Display plant information with a tree selector */}
      <HomePlant setTree={props.setTree} />

      <div className="home-sundarban reveal">
        <div className={`sdn-title ${langState === "bn" ? "bangla-font" : ""}`}>
          {t("home.sdn-title")}
        </div>
        <div
          className={`sdn-minititle ${langState === "bn" ? "bangla-font" : ""}`}
        >
          {t("home.sdn-minititle")}
        </div>
        <img
          className="sdn-linebrk"
          src="Assets/logo/linebreak.png"
          alt="line break"
        />
        <div className="sdn-container">
          <div
            className={`sdn-body ${langState === "bn" ? "bangla-font" : ""}`}
          >
            {t("home.sdn-body")}
          </div>
          <img
            className="sdn-tiger"
            src="Assets/logo/Sundarban.jpg"
            alt="Sundarban"
          />
        </div>
      </div>
      {/* Services section with links to different features */}
      <div className="home-service reveal">
        <div className={`sdn-title ${langState === "bn" ? "bangla-font" : ""}`}>
          {t("home.services")}
        </div>
        <div
          className={`sdn-minititle ${langState === "bn" ? "bangla-font" : ""}`}
        >
          SOME OF THE SERVICES YOU CAN GET FROM US
        </div>
        <img
          className="sdn-linebrk"
          src="Assets/logo/linebreak2.png"
          alt="line break"
        />
        <div className="sdn-grid">
          {/* Service 1: Plant Identification */}
          <Link to="/identify" className="service-link">
            <div className="service">
              <img
                src="Assets/logo/service1.png"
                className="service-icon"
                alt="Plant Identification"
              />
              <div className="service-desc-cont">
                <div className="service-name">Plant Identification</div>
                <div className="service-desc">
                  Identify your plants from the Sundarbans by uploading the
                  image.
                </div>
              </div>
            </div>
          </Link>

          {/* Service 2: Sundarbans Ecology */}
          <Link to="/species" className="service-link">
            <div className="service">
              <img
                src="Assets/logo/service2.png"
                className="service-icon"
                alt="Sundarbans Ecology"
              />
              <div className="service-desc-cont">
                <div className="service-name">Sundarbans Ecology</div>
                <div className="service-desc">
                  Get to know about the plant's species of the Sundarbans
                </div>
              </div>
            </div>
          </Link>

          {/* Service 3: API Integration */}
          <Link to="/userapi" className="service-link">
            <div className="service">
              <img
                src="Assets/logo/service3.png"
                className="service-icon"
                alt="API Integration"
              />
              <div className="service-desc-cont">
                <div className="service-name">API Integration</div>
                <div className="service-desc">
                  Integrate our application back-end interface to your own
                  application.
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
